import { useState } from "react";
import { Link } from "react-router-dom";
import { FaPlus } from "../../assets/icons/vander";
import { SecretaryLayout } from "../Layout";
import { AddWorkShifModal } from "../components/work_management/modals";
import { WorkShiftTable } from "../components/work_management/tables";
import {
  WorkShiftFilterForm,
  WorkShiftPagination,
} from "../components/work_management/forms";

export const RegisterShiftPage = () => {
  // Datos de hooks ----------------------------------------//
  // States ------------------------------------------------//
  const [isAddWorkShifModal, setIsAddWorkShifModal] = useState(false);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <>
      <SecretaryLayout>
        <div className="container-fluid">
          <div className="layout-specing">
            <div className="row">
              <div className="col-xl-9 col-md-6">
                <h5 className="mb-0">Registrar Jornada</h5>

                <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                  <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                    <li className="breadcrumb-item">
                      <Link to="/secretary/dashboard">gosafe</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Registrar Jornada
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="col-xl-3 col-md-6 mt-4 mt-md-0 text-md-end">
                <button
                  className="btn btn-icon btn-pills btn-primary btn-lg"
                  onClick={() => setIsAddWorkShifModal(true)}
                >
                  <FaPlus className="icons" />
                </button>
              </div>
            </div>

            <div className="mt-4">
              <WorkShiftFilterForm />
            </div>

            <div className="mt-4">
              <WorkShiftPagination />
            </div>

            <div className="mt-4">
              <WorkShiftTable />
            </div>
          </div>
        </div>
      </SecretaryLayout>

      <AddWorkShifModal
        isOpen={isAddWorkShifModal}
        setIsOpen={setIsAddWorkShifModal}
      />
    </>
  );
};
